module.exports = __webpack_public_path__ + "img/icon-clock-red.7c2b10cb.svg";